import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute } from '@angular/router';
import { Fido2Helper } from 'src/app/helpers/fido2.helper';
import { IInitiateMFAPayload, IMFAConfigList } from 'src/app/model/mfa.interface';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { ILocation, LocationHelper } from '../../../helpers/location.helper';
import {KEY_DEFAULT_ERROR} from '../../../model/error.model';

@Component({
  selector: 'app-mfa-required',
  templateUrl: './mfa-required.component.html',
  styleUrls: ['./mfa-required.component.scss'],
})
export class MfaRequiredComponent implements OnInit {
  contentLoading: boolean = false;
  verifyingInProgress = false;
  displayMFAList: any = [];
  noConfigurationFound = false;
  showMFAList = true;
  mfaTypeSelected = '';
  showInputField = false;
  showWaitingSymbol = true;
  otpCode = '';
  initiateResponse: any = {};
  errorMessage = '';
  authenticateResponse: any = {};
  inWaiting = false;
  localNavigator = window.navigator as any;
  mediumList: any = [];
  displayedColumns: string[] = ['id', 'key_name', 'notification'];
  multipleMFAType = '';
  sub = '';
  requestId = '';
  pushSelectedNumber = '';
  hint = '';
  nonDeviceMFATypes: string[] = ['EMAIL', 'SMS', 'TOTP', 'IVR', 'BACKUPCODE', 'PASSWORD'];
  inputGroupOption = {
    label: 'ENTER_VERIFICATION_CODE',
    placeholder: 'ENTER_VERIFICATION_CODE',
    type: 'text',
    hint: '',
    value: '',
    error: '',
    trim: true
  };
  passwordGroupOption = {
    label: 'LOGIN.AUTHENTICATION.PASSWORD.INPUT.LABEL',
    placeholder: 'LOGIN.AUTHENTICATION.PASSWORD.INPUT.PLACEHOLDER',
    hint: 'LOGIN.AUTHENTICATION.PASSWORD.INPUT.HINT',
    type: 'password',
    value: '',
    error: ''
  };

  buttonOptions: any = {
    verify: {
      color: 'accent',
      text: 'VERIFY',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  }
  listErrorMessage: string = '';
  location: ILocation = {
    lat: '',
    lon: '',
  };

  constructor(
    private cidaasService: CidaasService,
    private fidoHelper: Fido2Helper,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    public commonFunc: CommonFunctionsService,
    // private _spinner: SpinnerService
  ) { }

  ngOnInit(): void {
    this.initializeVariables();
    this.getConfiguredMFAList();
    this.getLatLon();
  }

  getLatLon(): void {
    const lat = localStorage.getItem('lat');
    const lon = localStorage.getItem('lon');
    if (lat && lon) {
      this.location.lat = lat;
      this.location.lon = lon;
    } else {
      LocationHelper.getLocationInfo().then((info: ILocation) => {
        this.location = info;
      }).catch((error) => {
        this.location.lat = '';
        this.location.lon = '';
      });
    }
  }

  // get sub and requestId from url
  initializeVariables(): void {
    this.sub = this.activatedRoute.snapshot.queryParams.sub || this.activatedRoute.snapshot.queryParams.q;
    this.requestId = this.activatedRoute.snapshot.queryParams.requestId || this.activatedRoute.snapshot.queryParams.requestid;
  }

  getInputStatus() {
    if (this.showInputField) {
      return true;
    }
    else {
      return false;
    }
  }

  // get list of configured mfas with sub and request id
  getConfiguredMFAList(): void {
    this.displayMFAList = [];
    // this._spinner._start();
    this.contentLoading = true;
    this.cidaasService
      .getMFAList({ sub: this.sub, request_id: this.requestId })
      .then((response) => {
        // this._spinner._stop();
        this.contentLoading = false;
        if (response && response.success && response.status === 200) {
          this.displayMFAList = response.data?.configured_list;
          if (this.displayMFAList && this.displayMFAList.length === 1) {
            this.triggerVerification(this.displayMFAList[0]);
            this.showMFAList = false;
          }
          this.noConfigurationFound = false;
        } else if (response.error) {
          if (response.error.status === 417) {
            this.listErrorMessage = 'NO_USER_FOUND';
          } else {
            this.listErrorMessage = KEY_DEFAULT_ERROR;
          }
        } else {
          this.noConfigurationFound = true;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  checkItemType(item: any): boolean {
    if (item && item.type == "PASSWORD") {
      return false
    }
    else {
      return true;
    }
  }

  // clicking on method from html
  chooseVerificationType(verificationMethod: IMFAConfigList, template?: TemplateRef<any>): void {
    this.mediumList = [];
    this.hint = '';
    this.otpCode = '';
    if (
      verificationMethod.mediums &&
      verificationMethod.mediums.length > 1 &&
      this.nonDeviceMFATypes.indexOf(verificationMethod.type) === -1
    ) {
      this.mediumList = verificationMethod.mediums;
      this.multipleMFAType = verificationMethod.type;
      if (template) {
        const dialogRef = this.dialog.open(template);
      }
    } else {
      this.triggerVerification(verificationMethod);
    }
  }

  // defining payload and calling initiate mfa
  triggerVerification(verification): void {
    this.errorMessage = '';
    const payload: IInitiateMFAPayload = {
      request_id: this.requestId,
      usage_type: 'MULTIFACTOR_AUTHENTICATION',
      sub: this.sub,
      type: verification.type,
    };
    if (verification.mediums && verification.mediums.length >= 1) {
      payload.medium_id = verification.mediums[0].id;
      this.initiateMFA(payload);
    } else {
      this.initiateMFA(payload);
    }
  }

  // calls initiate mfa with payload
  initiateMFA(verificationPayload): void {
    if (this.nonDeviceMFATypes.find((x) => x === verificationPayload.type) !== undefined || verificationPayload.type === 'FIDO2') {
      this.showInputField = true;
      this.showWaitingSymbol = false;
    } else {
      this.showInputField = false;
      this.showWaitingSymbol = true;
    }
    this.mfaTypeSelected = verificationPayload.type;

    // this._spinner._start();
    this.contentLoading = true;
    this.cidaasService
      .initiateMFAV2(verificationPayload)
      .then((data) => {
        // this._spinner._stop();
        this.contentLoading = false;
        if (data && data.success && data.data) {
          this.initiateResponse = data.data;
          if (verificationPayload.type !== 'FIDO2') {
            this.showMFAList = false;
          } else {
            this.showMFAList = true;
            this.fidoVerification();
          }
          if (data.data.push_selected_number) {
            this.pushSelectedNumber = data.data.push_selected_number;
          } else {
            this.pushSelectedNumber = '';
          }
          if (this.showWaitingSymbol) {
            this.inWaiting = true;
            this.checkSocketStatus(data.data.status_id);
          }
        } else {
          this.errorMessage = KEY_DEFAULT_ERROR;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  fidoVerification(): void {
    const publicKey = this.fidoHelper.preformatGetAssertReq(this.initiateResponse.fido2_entity.server_challenge);
    if (this.localNavigator.credentials && this.localNavigator.credentials.get) {
      this.localNavigator.credentials.get({ publicKey }).then((response) => {
        const makeCredResponse = this.fidoHelper.publicKeyCredentialToJSON(response);
        const authenticatePayload: any = {
          sub: this.sub,
          exchange_id: this.initiateResponse.exchange_id.exchange_id,
          type: this.mfaTypeSelected,
          fido2_client_response: {
            client_response: makeCredResponse,
            fidoRequestId: this.initiateResponse.fido2_entity.fidoRequestId,
          },
        };
        // this._spinner._start();
        this.contentLoading = true;
        this.cidaasService
          .authenticateMFAV2(authenticatePayload)
          .then((data) => {
            // this._spinner._stop();
            this.contentLoading = false;
            if (data && data.success && data.data) {
              this.authenticateResponse = data.data;
              this.loginPrecheck();
            } else {
              this.errorMessage = KEY_DEFAULT_ERROR;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      });
    }
  }

  // button click on cancel authorization, calls cancel method of sdk
  cancelAuth(): void {
    this.showMFAList = true;
    const cancelPayload: any = {
      type: this.mfaTypeSelected,
      reason: 'back clicked',
    };
    if (this.initiateResponse && this.initiateResponse.exchange_id && this.initiateResponse.exchange_id.exchange_id) {
      cancelPayload.exchange_id = this.initiateResponse.exchange_id.exchange_id;
    }
    // this._spinner._start();
    this.contentLoading = true;
    this.cidaasService
      .cancelMFAV2(cancelPayload)
      .then((data) => {
        // this._spinner._stop();
        this.contentLoading = false;
        if (data && data.success && data.data) {
          this.inWaiting = false;
        } else {
          this.inWaiting = false;
          this.errorMessage = KEY_DEFAULT_ERROR;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // click to verify authentication
  verifyAuth(): void {
    const mfaType = this.mfaTypeSelected;
    const payload = {
      exchange_id: this.initiateResponse.exchange_id.exchange_id,
      sub: this.sub,
      type: mfaType,
    };
    if (mfaType.toLowerCase() === 'password') {
      payload['password'] = this.otpCode;
    } else {
      payload['pass_code'] = this.otpCode;
    }
    if (this.otpCode) {
      // this._spinner._start();
      this.verifyingInProgress = true;
      this.cidaasService
        .authenticateMFAV2(payload)
        .then((data) => {
          // this._spinner._stop();
          this.verifyingInProgress = false;
          if (data && data.success && data.data) {
            this.authenticateResponse = data.data;
            this.loginPrecheck();
          } else if (data && data.error && data.error.error === 'Invalid pass_code or already used') {
            this.errorMessage = 'INVALID_CODE';
          } else if (data && data.error && data.error.error === 'Invalid password') {
            this.errorMessage = 'INVALID_USERNAME_PASSWORD';
          } else {
            this.errorMessage = KEY_DEFAULT_ERROR;
          }
        })
        .catch((e) => {
          console.log(e);
          this.verifyingInProgress = false;
        });
    } else {
      this.hint = 'REQUIRED_FIELD';
    }
  }

  // calling login precheck method that on success will redirect to redirect url of app
  loginPrecheck(): void {
    // this._spinner._start();
    this.contentLoading = true;
    this.cidaasService.mfaContinue({
      status_id: this.authenticateResponse.status_id,
      sub: this.sub,
      requestId: this.requestId,
      verificationType: this.mfaTypeSelected,
      track_id: this.activatedRoute.snapshot.queryParams.track_id,
      lat: this.location.lat,
      lon: this.location.lon,
    });
    this.contentLoading = false;
  }

  // checks status of authentication (device authentication)
  checkSocketStatus(statusId): void {
    this.cidaasService
      .getMFAStatus(statusId)
      .then((data) => {
        if (data && data.status === 200 && data.success) {
          if (data.data.status === 'AUTHENTICATED') {
            this.inWaiting = false;
            this.authenticateResponse.status_id = statusId;
            this.loginPrecheck();
          } else if (data.data.status === 'REJECTED_BY_USER') {
            this.inWaiting = false;
            this.errorMessage = 'ERROR-OCCURED';
            this.showMFAList = true;
            this.listErrorMessage = 'AUTHENTICATED_REQUEST_DENIED';
          } else if (data.data.status === 'AUTHENTICATION_CANCELLED') {
            this.inWaiting = false;
            this.errorMessage = 'ERROR-OCCURED';
            this.cancelAuth();
          }
          if (this.inWaiting) {
            setTimeout(() => {
              this.checkSocketStatus(statusId);
            }, 3000);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // select device from popup, close popup and call triggerVerification
  selectDevice(device): void {
    this.dialog.closeAll();
    this.triggerVerification({ type: this.multipleMFAType, mediums: [device] });
  }

  // sets the code from input field
  setCode(data: any): void {
    this.otpCode = data || undefined;
  }

  //check verify button is required in UI or not
  isVerifyButtonRequired() {
    return (this.mfaTypeSelected === 'PASSWORD' ||
      this.mfaTypeSelected === 'EMAIL' ||
      this.mfaTypeSelected === 'SMS' ||
      this.mfaTypeSelected === 'TOTP' ||
      this.mfaTypeSelected === 'BACKUPCODE' ||
      this.mfaTypeSelected === 'IVR');
  }
}
